import React from "react";

// Media Logos - Using local files
export const MEDIA_LOGOS = {
  // French News Agencies
  afp: "/logo_afp.png",
  reuters: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Reuters_Logo.svg/200px-Reuters_Logo.svg.png",
  
  // TV Channels
  bfm: "/logo_bfmtv.jpg",
  bfm_tv: "/logo_bfmtv.jpg",
  bfmtv: "/logo_bfmtv.jpg",
  france_info: "/logo_franceinfo.jpg",
  franceinfo: "/logo_franceinfo.jpg",
  france_2: "https://upload.wikimedia.org/wikipedia/fr/thumb/3/3e/France_2_2018.svg/200px-France_2_2018.svg.png",
  france_3: "https://upload.wikimedia.org/wikipedia/fr/thumb/9/9a/France_3_2018.svg/200px-France_3_2018.svg.png",
  tf1: "https://upload.wikimedia.org/wikipedia/fr/thumb/d/dc/TF1_logo_2013.svg/200px-TF1_logo_2013.svg.png",
  cnews: "https://upload.wikimedia.org/wikipedia/fr/thumb/c/c7/CNews_logo.svg/200px-CNews_logo.svg.png",
  lci: "https://upload.wikimedia.org/wikipedia/fr/thumb/5/5f/LCI_logo_%282016%29.svg/200px-LCI_logo_%282016%29.svg.png",
  
  // Radio
  rtl: "/logo_rtl.png",
  europe1: "/logo_europe1.png",
  europe_1: "/logo_europe1.png",
  rmc: "/logo_rmc.png",
  france_inter: "https://upload.wikimedia.org/wikipedia/fr/thumb/2/24/France_Inter_logo_2021.svg/200px-France_Inter_logo_2021.svg.png",
  france_bleu: "/logo_ici.png",
  france_bleu_ici: "/logo_ici.png",
  ici: "/logo_ici.png",
  
  // Press - National
  le_monde: "/logo_lemonde.jpg",
  lemonde: "/logo_lemonde.jpg",
  le_figaro: "/logo_lefigaro.svg",
  lefigaro: "/logo_lefigaro.svg",
  liberation: "/logo_liberation.png",
  libération: "/logo_liberation.png",
  les_echos: "/logo_lesechos.png",
  lesechos: "/logo_lesechos.png",
  mediapart: "/logo_mediapart.jpg",
  economie_matin: "/logo_economiematin.png",
  
  // Press - Regional
  ouest_france: "https://upload.wikimedia.org/wikipedia/fr/thumb/8/84/Ouest-France_logo.svg/200px-Ouest-France_logo.svg.png",
  la_depeche: "https://upload.wikimedia.org/wikipedia/fr/thumb/c/c2/La_D%C3%A9p%C3%AAche_du_Midi_%28logo%29.svg/200px-La_D%C3%A9p%C3%AAche_du_Midi_%28logo%29.svg.png",
};

// Social Network Logos with colors
export const SOCIAL_LOGOS = {
  twitter: {
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/X_logo_2023.svg/200px-X_logo_2023.svg.png",
    color: "#000000",
    name: "X",
    bgColor: "bg-gray-800/20"
  },
  x: {
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/X_logo_2023.svg/200px-X_logo_2023.svg.png",
    color: "#000000",
    name: "X",
    bgColor: "bg-gray-800/20"
  },
  facebook: {
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Facebook_Logo_%282019%29.png/200px-Facebook_Logo_%282019%29.png",
    color: "#1877F2",
    name: "Facebook",
    bgColor: "bg-[#1877F2]/10"
  },
  instagram: {
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/200px-Instagram_logo_2016.svg.png",
    color: "#E4405F",
    name: "Instagram",
    bgColor: "bg-gradient-to-br from-purple-500/10 to-pink-500/10"
  },
  linkedin: {
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/200px-LinkedIn_logo_initials.png",
    color: "#0A66C2",
    name: "LinkedIn",
    bgColor: "bg-[#0A66C2]/10"
  },
  tiktok: {
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/a/a9/TikTok_logo.svg/200px-TikTok_logo.svg.png",
    color: "#00F2EA",
    name: "TikTok",
    bgColor: "bg-gradient-to-br from-[#00F2EA]/20 to-[#FF0050]/20"
  },
  youtube: {
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/200px-YouTube_full-color_icon_%282017%29.svg.png",
    color: "#FF0000",
    name: "YouTube",
    bgColor: "bg-red-500/10"
  }
};

// Media Logo Component
export const MediaLogo = ({ source, size = "md" }) => {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8", 
    lg: "w-12 h-12"
  };
  
  const getLogoUrl = (sourceName) => {
    const lower = sourceName?.toLowerCase() || "";
    if (lower.includes("afp")) return MEDIA_LOGOS.afp;
    if (lower.includes("bfm")) return MEDIA_LOGOS.bfm;
    if (lower.includes("france info") || lower.includes("franceinfo")) return MEDIA_LOGOS.france_info;
    if (lower.includes("france 2")) return MEDIA_LOGOS.france_2;
    if (lower.includes("france 3")) return MEDIA_LOGOS.france_3;
    if (lower.includes("france bleu")) return MEDIA_LOGOS.france_bleu;
    if (lower.includes("france inter")) return MEDIA_LOGOS.france_inter;
    if (lower.includes("tf1")) return MEDIA_LOGOS.tf1;
    if (lower.includes("cnews")) return MEDIA_LOGOS.cnews;
    if (lower.includes("lci")) return MEDIA_LOGOS.lci;
    if (lower.includes("rtl")) return MEDIA_LOGOS.rtl;
    if (lower.includes("europe 1")) return MEDIA_LOGOS.europe1;
    if (lower.includes("rmc")) return MEDIA_LOGOS.rmc;
    if (lower.includes("le monde")) return MEDIA_LOGOS.le_monde;
    if (lower.includes("figaro")) return MEDIA_LOGOS.le_figaro;
    if (lower.includes("liberation") || lower.includes("libé")) return MEDIA_LOGOS.liberation;
    if (lower.includes("echos")) return MEDIA_LOGOS.les_echos;
    if (lower.includes("ouest france") || lower.includes("ouest-france")) return MEDIA_LOGOS.ouest_france;
    if (lower.includes("dépêche") || lower.includes("depeche")) return MEDIA_LOGOS.la_depeche;
    if (lower.includes("reuters")) return MEDIA_LOGOS.reuters;
    return null;
  };

  const logoUrl = getLogoUrl(source);
  
  if (!logoUrl) {
    return (
      <div className={`${sizeClasses[size]} rounded bg-primary/20 flex items-center justify-center`}>
        <span className="text-xs font-bold text-primary">{source?.charAt(0) || "M"}</span>
      </div>
    );
  }
  
  return (
    <img 
      src={logoUrl} 
      alt={source} 
      className={`${sizeClasses[size]} object-contain rounded bg-white/90 p-0.5`}
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
};

// Social Network Logo Component
export const SocialLogo = ({ platform, size = "md" }) => {
  const sizeClasses = {
    sm: "w-5 h-5",
    md: "w-6 h-6", 
    lg: "w-8 h-8"
  };
  
  const getPlatformData = (platformName) => {
    const lower = platformName?.toLowerCase() || "";
    if (lower.includes("twitter") || lower === "x" || lower.includes(" x ")) return SOCIAL_LOGOS.x;
    if (lower.includes("facebook") || lower.includes("fb")) return SOCIAL_LOGOS.facebook;
    if (lower.includes("instagram") || lower.includes("insta")) return SOCIAL_LOGOS.instagram;
    if (lower.includes("linkedin")) return SOCIAL_LOGOS.linkedin;
    if (lower.includes("tiktok")) return SOCIAL_LOGOS.tiktok;
    if (lower.includes("youtube")) return SOCIAL_LOGOS.youtube;
    return null;
  };

  const platformData = getPlatformData(platform);
  
  if (!platformData) {
    return (
      <div className={`${sizeClasses[size]} rounded-full bg-primary/20 flex items-center justify-center`}>
        <span className="text-[10px] font-bold text-primary">#</span>
      </div>
    );
  }
  
  return (
    <div className={`${sizeClasses[size]} rounded-sm overflow-hidden flex items-center justify-center ${
      platform?.toLowerCase()?.includes('tiktok') ? 'bg-white p-0.5' : ''
    }`}>
      <img 
        src={platformData.logo} 
        alt={platform} 
        className="w-full h-full object-contain"
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
    </div>
  );
};

// Social Post Component with likes, comments, shares
export const SocialPostCard = ({ 
  platform, 
  author, 
  content, 
  time, 
  likes = 0, 
  comments = 0, 
  shares = 0,
  isVerified = false,
  profilePic = null,
  onClick
}) => {
  const platformData = SOCIAL_LOGOS[platform?.toLowerCase()] || SOCIAL_LOGOS.twitter;
  
  return (
    <div 
      className={`rounded-lg border border-border p-3 ${platformData.bgColor} cursor-pointer hover:border-primary/50 transition-colors`}
      onClick={onClick}
    >
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <SocialLogo platform={platform} size="sm" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1">
            <span className="font-semibold text-sm truncate">{author}</span>
            {isVerified && <span className="text-blue-500">✓</span>}
          </div>
          <span className="text-xs text-muted-foreground">{time}</span>
        </div>
      </div>
      
      {/* Content */}
      <p className="text-sm mb-3 whitespace-pre-wrap">{content}</p>
      
      {/* Engagement */}
      <div className="flex items-center gap-4 text-xs text-muted-foreground">
        <span className="flex items-center gap-1">
          <span>❤️</span> {likes > 1000 ? `${(likes/1000).toFixed(1)}K` : likes}
        </span>
        <span className="flex items-center gap-1">
          <span>💬</span> {comments}
        </span>
        <span className="flex items-center gap-1">
          <span>🔄</span> {shares}
        </span>
      </div>
    </div>
  );
};

export default { MediaLogo, SocialLogo, SocialPostCard, MEDIA_LOGOS, SOCIAL_LOGOS };
